import React, { useState } from "react";
import QueryBuilder from "react-querybuilder";
import "react-querybuilder/dist/query-builder.css";
import fields from "./src/fields.js";
import getOperators from "./src/operators.js";
import { Button } from "react-bootstrap";
import BootstrapActionElement from "./src/BootstrapActionElement";
import BootstrapValueSelector from "./src/BootstrapValueSelector";
import BootstrapNotToggle from "./src/BootstrapNotToggle";
import BootstrapValueEditor from "./src/BootstrapValueEditor";
import { logger } from "../../util";
import { useDispatch } from "react-redux";
import { setQuery } from "../../state/slices/query";

const debug = logger("QueryBuilder/index.js");

function MyQueryBuilder(props) {
  const [theQuery, setTheQuery] = useState({
    id: "root",
    combinator: "and",
    rules: [],
  });

  const dispatch = useDispatch();

  const applyQuery = (event) => {
    event.preventDefault();
    debug("applyQuery");
    dispatch(setQuery(theQuery));
  };

  return (
    <div>
      <QueryBuilder
        fields={fields}
        getOperators={getOperators}
        onQueryChange={(q) => setTheQuery(q)}
        query={theQuery}
        controlElements={{
          addGroupAction: BootstrapActionElement,
          addRuleAction: BootstrapActionElement,
          combinatorSelector: BootstrapValueSelector,
          fieldSelector: BootstrapValueSelector,
          notToggle: BootstrapNotToggle,
          operatorSelector: BootstrapValueSelector,
          removeGroupAction: BootstrapActionElement,
          removeRuleAction: BootstrapActionElement,
          valueEditor: BootstrapValueEditor,
        }}
      />
      <br />
      <Button variant="primary" onClick={applyQuery}>
        Apply
      </Button>
    </div>
  );
}

export default MyQueryBuilder;
